import { Accordion, Button, Card, Center, Group, Loader, Stack, Text } from '@mantine/core';
import { IconFileCode } from '@tabler/icons-react';

import { useTestGenerator } from '@admin/hooks';
import { PhaseAccordionItem } from './PhaseAccordionItem';

import type { TestPhase } from '@admin/hooks/request-logger/useTestGenerator';

interface ReviewFlowStepProps {
  batchId: string;
  selectedTemplate: string;
  onExport: () => void;
  isExporting: boolean;
  onRequestClick?: (requestId: string) => void;
}

export const ReviewFlowStep = ({ batchId, selectedTemplate, onExport, isExporting, onRequestClick }: ReviewFlowStepProps) => {
  const { data: testData, isLoading: isLoadingTest } = useTestGenerator(batchId, selectedTemplate, !!batchId);

  if (isLoadingTest) {
    return (
      <Stack gap="md" mt="md">
        <Center p="xl">
          <Loader size="lg" />
        </Center>
      </Stack>
    );
  }

  if (!testData) {
    return (
      <Stack gap="md" mt="md">
        <Center p="xl">
          <Text size="sm" c="dimmed">
            No data available
          </Text>
        </Center>
      </Stack>
    );
  }

  return (
    <Stack gap="md" mt="md">
      <Card shadow="sm" padding="md" radius="md" withBorder>
        <Group justify="space-between">
          <Stack gap="xs">
            <Text size="sm" fw={600}>
              Batch: {testData.batch.name}
            </Text>
            <Text size="xs" c="dimmed">
              Counter: {testData.batch.counter} | Template: {testData.template.name}
            </Text>
          </Stack>
          <Button onClick={onExport} loading={isExporting} leftSection={<IconFileCode size={16} />}>
            Generate Test Definition
          </Button>
        </Group>
      </Card>

      {testData.phases.length === 0 ? (
        <Center p="xl">
          <Text size="sm" c="dimmed">
            No requests found for this batch
          </Text>
        </Center>
      ) : (
        <Accordion>
          {testData.phases.map((phase: TestPhase, index: number) => (
            <PhaseAccordionItem key={index} phase={phase} index={index} onRequestClick={onRequestClick} />
          ))}
        </Accordion>
      )}
    </Stack>
  );
};
